import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
//import { FroalaEditorOptions } from 'src/app/data/constants/froala-editor-options';
import { ImagilityBaseResponse } from 'src/app/data/models/response.model';
import { select, Store } from '@ngrx/store';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { getStepStatusUpdate } from '../../store/selectors/step-status-update.selectors';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { GCI140Service } from '../../../../services/gci140.service';
import { NgForm } from '@angular/forms';
import { map } from 'rxjs/operators';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { UploadImageDialogComponent } from "../../../custom-kendo/upload-image-dialog/upload-image-dialog.component";
import { EditorComponent } from "@progress/kendo-angular-editor";
@Component({
  selector: 'app-create-template',
  templateUrl: './create-template.component.html',
  styleUrls: ['./create-template.component.scss']
})
export class CreateTemplateComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('createTemplateForm', { static: true }) createTemplateForm: NgForm;
  // public options = FroalaEditorOptions.EditorOptions;
  @ViewChild("templateHeaderupload") public templateHeaderupload: UploadImageDialogComponent;
  @ViewChild("templateContentupload") public templateContentupload: UploadImageDialogComponent;
  @ViewChild("templateFooterupload") public templateFooterupload: UploadImageDialogComponent;
  @Output() @ViewChild("templateHeaderkendoeditor") public templateHeaderkendoeditor: EditorComponent;
  @Output() @ViewChild("templateContentkendoeditor") public templateContentkendoeditor: EditorComponent;
  @Output() @ViewChild("templateFooterkendoeditor") public templateFooterkendoeditor: EditorComponent;
  taskDetailsSubscription$ = new Subject();
  template: {
    header: string,
    body: string,
    footer: string,
  }
  letterType: string;
  taskDetails: any;
  stepDetails: TaskStep;
  typeOfButton: string; // This is required for status update button
  observableSubscription$ = new Subject();
  disabledControls: boolean;

  @Output()
  redirectionComponent: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private gcI140Service: GCI140Service,
    private toast: ToastrService,
    protected store: Store<any>,
    private dynamicDialogConfig: DynamicDialogConfig,
  ) {
    this.disabledControls = false;
    this.letterType = sessionStorage.getItem('typeOfLetter');
    this.template = {
      header: '',
      body: '',
      footer: ''
    }
  }

  ngOnInit(): void {
    // Selector for step status update
    this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toast.success(response.message, 'Success');
        this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
      }
    });

    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      this.getTemplateDetails();
    });

  }

  ngAfterViewInit() {
    this.createTemplateForm.form.valueChanges.pipe(
      map(() => this.createTemplateForm.dirty),
    ).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
      if (dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }
  public opentemplateHeaderimageuploaddialog() {    
    this.templateHeaderupload.open();
  }
  public templateContentimageuploaddialog() {    
    this.templateContentupload.open();
  }
  public templateFooterimageuploaddialog() {    
    this.templateFooterupload.open();
  }
  getTemplateDetails() {
    this.gcI140Service.getLetterType(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, this.letterType).subscribe((response: ImagilityBaseResponse) => {
      this.template = response && response.data ? response.data : {
        header: '', body: '',
        footer: ''
      };
    });
  }

  handleSaveTemplate() {
    let payload = {
      header: this.template.header,
      body: this.template.body,
      footer: this.template.footer
    }
    this.gcI140Service.postLetterType(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, this.letterType, payload).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        let test = 0;
        sessionStorage.setItem('documentTemplateId', (test).toString());
        this.toast.success(response.message, 'Success');
        this.createTemplateForm.resetForm(this.createTemplateForm.value);
        this.getTemplateDetails();
        this.redirectionComponent.emit('LetterPreview');
      }
    });
  }

  handleCancel() {
    this.getTemplateDetails();
  }

  handleBack() {
    this.redirectionComponent.emit('LetterTemplate');
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
  public templateheadereditorValueChange(value: string): void {
    this.template.header = value;
  }
  public templatebodyeditorValueChange(value: string): void {
    this.template.body = value;
  }
  public templatefootereditorValueChange(value: string): void {
    this.template.footer = value;
  }
}
